"use strict";
exports.__esModule = true;
exports.POLICY_SOURCE_TYPES = void 0;
exports.POLICY_SOURCE_TYPES = ['COMPANY', 'PROPERTY'];
//# sourceMappingURL=policy-source-types.constants.js.map